import axios from "axios";

import { config } from "../../config";
import { apiVersionPrefix } from "../../paths";

const END_POINT: string = `${apiVersionPrefix}/users/list_by_business`;

export interface BusinessUser {
  id: string;
  firstName: string;
  lastName: string;
  defaultTravelerId: string;
}

export interface UsersForBusiness {
  businessId: string;
  users: BusinessUser[];
  error?: string;
}

export interface IFetchUsersByBusinessResponse {
  businesses: UsersForBusiness[];
}

export const fetchUsersByBusiness = async (
  businessIds: string[]
): Promise<IFetchUsersByBusinessResponse> => {
  const res = await axios.put(
    END_POINT,
    { businessIds },
    { baseURL: config.baseURL }
  );
  return res.data;
};
